
import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { constObj } from '../../../common/Constants/constants';
import { userModel } from '../../../common/models/MyAccountDetails';
import { CommonDataService } from '../../../common/services/common-data.service';
import { ConfigurationService } from '../../../common/services/configuration.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { LoginService } from '../../../common/services/Login.service';
import { OpenLinkById } from '../../../common/services/openlinkbyid';
import { SessionService } from '../../../common/services/Session.service';
import { ValidationService } from '../../../common/services/validation.service';


@Component({
  selector: 'app-login-home',
  templateUrl: './login-home.component.html',
  styleUrls: ['./login-home.component.css']
})
export class LoginHomeComponent implements OnInit, AfterViewChecked, AfterViewInit {

  @ViewChild('loginUsernameLabel') userNameElement: ElementRef;
  @ViewChild('loginPasswordLabel') passwordElement: ElementRef;

  hide = true;  // For password field
  userName: string = ""; //for username
  passWord: string = ""; //for username
  minPw: number = 8;
  WarningMessage: string;
  basicAccInfo: string;
  public aFormGroup: FormGroup;
  public FormGroup: FormGroup;
  apiError: boolean = false;
  usernameError
  passwordError;
  usernameLabel;
  passwordLabel
  LoginFailed: any;
  ProfessionalViewHeader: any;
  ViewHeader: any;
  ProfessionalViewConent: any;
  ViewConent: any;
  siteKey: string = "";
  usageText: any;
  AcademicViewContent: any;
  showAcademicView: any;
  AcademicViewHeader: any;
  leftPannelTitle: string;
  usernameInput: any;
  usernameDescription: any;
  passwordInput: any;
  passwordDescription: any;
  loginButton: any;
  forgotPassword: any;
  renewSubscription: any;
  renewSubscriptionURL: any;
  rightPanelTitle1: any;
  rightPanelTitle2: any;
  rightPanelDescription: any;
  accessBasicViewButton: any;
  whatHappenedBasicView: any;
  AdminErrorMessage = constObj.AdminErrorMessage;
  contactFASBSupport: any;
  accountAdministrationFAQ: any;
  Signupnow: any;
  SignupnowLink: any;
  AcademicViewLink: any;
  AcademicViewLinkText: any;
  Termandcondition: any;
  logo: any;
  loadpagecontent: boolean = false;
  additionalInfo: any;
  recaptchaforprof: boolean = false;
  recaptchaforprofverified: boolean = false;
  loginConcurrencyCheck: boolean = false;
  adminUser: boolean = false;
  userLoggedInList: userModel[];
  concurrencyError: any;
  error: boolean = false;
  recaptchaerror: string;
  recaptchaerrorflag: boolean = false;
  loginerror: boolean = false;
  popup = false
  @ViewChild('captchaRef2') captchaRef2: ElementRef;
  _reCaptchaId: number;
  constructor(
    private route: Router,
    private _loginservice: LoginService,
    private formBuilder: FormBuilder,
    private _validationService: ValidationService,
    private _commonDataService: CommonDataService,
    private _configurationservice: ConfigurationService,
    private graphQlService: GraphqlService,
    private domSanitizer: DomSanitizer,
    private openlinkid: OpenLinkById,
    private session: SessionService
  ) {

  }

  emailFormControl = new FormControl('');
  passwordvalidation = new FormControl('');
  captchaToken: string = "";

  public resolved(captchaResponse: string): void {
    this.captchaToken = captchaResponse;
    this._loginservice.verifyReCaptcha(this.captchaToken).subscribe(data => {
      if (data) {
        document.getElementById("btnBasicView").removeAttribute("disabled");
        document.getElementById("btnBasicView").classList.remove("btn-secondary-disabled-basic");
        document.getElementById("btnBasicView").classList.add("btn-primary-professional", "cursor-pointer");
      }
      else { this.route.navigateByUrl("/Login"); }
    });
  }
  public errorrecap(): void {
    this.captchaToken = "";
    document.getElementById("btnBasicView").setAttribute("disabled", "true");
    document.getElementById("btnBasicView").classList.add("btn-secondary-disabled-basic");
    document.getElementById("btnBasicView").classList.remove("btn-primary-professional", "cursor-pointer");
  }

  public errorrecapProf(): void {

    this.recaptchaforprofverified = false;
  }
  s3bucketbaseurl;
  ngOnInit() {
    this.clearSession();
    localStorage.removeItem("isPendingContentPage");
    localStorage.removeItem("SetPrintQueueSession");
    localStorage.removeItem("PCSIntegratedData");
    this.firstTimeFlag = true;
    this.showLoader();
    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });
    this.FormGroup = this.formBuilder.group({
      recaptchaProf: ['', Validators.required]
    });
    const obj = {
      crumbData: [],
      menuData: []
    }
    this._commonDataService.navData.next(obj);
    forkJoin([
      this.graphQlService.SetPendingContentAgreementSession(false),
      this.graphQlService.getS3BucketPath(),
      this._loginservice.getSiteKey(),
      this.graphQlService.getLoginPageContent()
    ]).subscribe(([pcs,s3bucketbaseurl, siteKey,profContent]) => {
      this.s3bucketbaseurl = s3bucketbaseurl;
      this.siteKey = siteKey.result;
      this.getProfessionalContent(profContent);
    }, err => { console.log(err); this._commonDataService.showLoader.next(false); });
    this.loadLogo();
    //this.getValidationError();
    localStorage.removeItem("publpageId");
    //this._commonDataService.refreshValidation.subscribe(data => {
    //  if (data) {
    //    this.getValidationError();
    //  }
    //});

    localStorage.removeItem("leftNavigationMenu");
    this.graphQlService.getLeftNavigation().subscribe(leftNavigationData => {
      localStorage.setItem("rawLeftNavigationMenu", JSON.stringify(leftNavigationData));
    });
  }
  //clearSession() {
  //  this._loginservice.deleteSession().subscribe();
  //}
  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {
    if (this.firstTimeFlag) {
      this.anchorColorChange();
      this.firstTimeFlag = false;
    }
  }
  openLogoutUsers() {
    this._commonDataService.showRightPanel.next(true);
    this._commonDataService.rightOverlayOption.next("Logout Users");
    this._commonDataService.rightPanelWidth.next("rightOverlay_large");

  }

  clearSession() {
    this._loginservice.deleteSession().subscribe();
    this.session.assignUserInfo(null);
  }

  anchorColorChange() {
    let items = document.getElementById('profContent')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;

    let ele = document.getElementById('academicviewcontent')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;


    if (items != undefined) {
      for (let i = 0; i < items.length; i++) {
        let element = items[i];
        element.style.color = "#005CBF";
      }
    }

    if (ele != undefined) {
      for (let j = 0; j < ele.length; j++) {
        let elee = ele[j];
        elee.style.color = "#005CBF";
      }
    }

  }

  //getValidationError() {
  //  if (localStorage.getItem("showLoginValidation") == "" || localStorage.getItem("showLoginValidation") == undefined  ||localStorage.getItem("showLoginValidation") == null || localStorage.getItem("showLoginValidation") == "true") {
  //    this._loginservice.getValidationError().subscribe(data => {
  //      if (data != "" && data != null && data.userValidation != "" && data.userValidation != null) {
  //        this.loginConcurrencyCheck = true;
  //        this.apiError = true;
  //        localStorage.setItem("showLoginValidation", "false");
  //        this.concurrencyError = this.domSanitizer.bypassSecurityTrustHtml(data.userValidation);
  //        if (data.userModel != null && data.userModel.length > 0) {
  //          this.adminUser = true;
  //          this.userLoggedInList = data.userModel;
  //        }
  //        else {
  //          this.adminUser = false;
  //        }
  //      }
  //      else {
  //        this.loginConcurrencyCheck = false;
  //        this.apiError = false;
  //        this.adminUser = false;
  //      }
  //    });
  //  }
  //  else {
  //    this.loginConcurrencyCheck = false;
  //    this.apiError = false;
  //    this.adminUser = false;
  //  }
  //}
  //Logout(data) {
  //  this.showLoader();
  //  this._loginservice.LogoutUser(data).subscribe(res => {
  //    this.hideLoader();
  //    if (res.valid) {
  //      this.getValidationError();
  //    }
  //  })
  //}
  getProfessionalContent(data) {

    if (data != null) {
      this.loadpagecontent = true;
      var labels = data.content.data.labels
      labels = labels.filter(x => x.key.trim());
      this.ProfessionalViewHeader = labels.filter(x => x.key == "login_whatYouGetTitle").map(y => y.value);
      this.ProfessionalViewConent = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "login_whatYouGetBody").map(y => y.value));
      this.ViewHeader = labels.filter(x => x.key == "loginView_whatYouGetTitle").map(y => y.value);
      this.ViewConent = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "loginView_WhatYouGetDescription").map(y => y.value));
      this.Signupnow = labels.filter(x => x.key == "login_signUpNow").map(y => y.value);
      this.SignupnowLink = labels.filter(x => x.key == "login_signupNowLink").map(y => y.value);
      this.AcademicViewContent = labels.filter(x => x.key == "login_academicViewBody").map(y => y.value);
      this.AcademicViewHeader = labels.filter(x => x.key == "login_academicViewTitle").map(y => y.value);
      this.leftPannelTitle = labels.filter(x => x.key == "login_leftPanelTitle").map(y => y.value);
      this.usernameInput = labels.filter(x => x.key == "login_usernameInput").map(y => y.value);
      this.usernameDescription = labels.filter(x => x.key == "login_usernameDescription​").map(y => y.value);
      this.passwordInput = labels.filter(x => x.key == "login_passwordInput ").map(y => y.value);
      this.passwordDescription = labels.filter(x => x.key == "login_passwordDescription").map(y => y.value);
      this.loginButton = labels.filter(x => x.key == "login_Button").map(y => y.value);
      this.forgotPassword = labels.filter(x => x.key == "login_forgotPassword").map(y => y.value);
      this.renewSubscription = labels.filter(x => x.key == "login_renewSubscription").map(y => y.value);
      this.renewSubscriptionURL = this.domSanitizer.bypassSecurityTrustResourceUrl(labels.filter(x => x.key == "login_renewSubscriptionURL").map(y => y.value));
      this.accountAdministrationFAQ = this.domSanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "login_accountAdministrationFAQ").map(y => y.value));
      this.rightPanelTitle1 = labels.filter(x => x.key == "login_rightPanelTitle1").map(y => y.value);
      this.rightPanelTitle2 = labels.filter(x => x.key == "login_rightPanelTitle2").map(y => y.value); 
      this.accessButtonTitle = labels.filter(x => x.key == "login_accessButtonTitle").map(y => y.value);
      var rightDescription = labels.filter(x => x.key == "login_AgreementSignDescription").map(y => y.value)[0];
      rightDescription = rightDescription?.split("<");
      this.rightPanelDescription = rightDescription[0];
      this.Termandcondition = rightDescription[1].split(">")[1];
      this.accessBasicViewButton = labels.filter(x => x.key == "login_accessButton").map(y => y.value); 
      this.usageText = labels.filter(x => x.key == "login_usageText").map(y => y.value);
      this.whatHappenedBasicView = labels.filter(x => x.key == "login_whatHappenedBasicView").map(y => y.value);
      this.contactFASBSupport = labels.filter(x => x.key == "login_contactFASBSupport").map(y => y.value);
      this.additionalInfo = labels.filter(x => x.key == "login_additionalInfo").map(y => y.value);

      this.hideLoader();
    }
    else {
      //TODO : check the negative scenario
      this.hideLoader();
    }
  }
  accessButtonTitle: string = "";
  Signup() {
    window.open(this.SignupnowLink);
  }
  accessBasicView() {
    this.showTC(false);
  }
  AccountFAQ() {
    this.route.navigate(["FAQ"]);
  }
  TermsandCondition() {
    this.route.navigate(["Terms"]);
  }
  //keyenter() {
  //  this.loginProfessional();
  //}

  checkEmail() {
    let emailValid = true
    if (!this._validationService.validateRequiredField(this.emailFormControl.value)) {
      this.emailFormControl.setErrors({ 'required': true });
      this.usernameError = this._validationService.getErrorMessage('required', this.usernameInput, null);
      this.emailFormControl.markAsTouched();
      emailValid = false
    }
    //else if (!this._validationService.validateEmail(this.emailFormControl.value)) {
    //  this.emailFormControl.setErrors({ 'hasInvalidEmail': true });
    //  this.usernameError = this._validationService.getErrorMessage('valid', "Email address", null);
    //  this.emailFormControl.markAsTouched();
    //  emailValid = false
    //}
    else if (!this._validationService.validateEmailformat(this.emailFormControl.value) || !this._validationService.validateEmailfullformat(this.emailFormControl.value)
      || !this._validationService.validateEmailspecialCharformat(this.emailFormControl.value) || !this._validationService.validatemailpostionRegexformat(this.emailFormControl.value)) {
      this.emailFormControl.setErrors({ 'hasInvalidEmail': true });
      this.usernameError = this._validationService.getErrorMessage('valid', "email address", null);
      this.emailFormControl.markAsTouched();
      emailValid = false
    }
    if (emailValid) {
      this.emailFormControl.setErrors(null);
    }

    return emailValid;
  }

  //checkPassword() {
  //  let passwordValid = true;
  //  if (this.checkEmail() == true) {
  //    if (!this._validationService.validateRequiredField(this.passwordvalidation.value)) {
  //      this.passwordvalidation.setErrors({ 'isEmpty': true });
  //      this.passwordError = this._validationService.getErrorMessage('required', this.passwordInput, null);
  //      this.passwordvalidation.markAsTouched();
  //      passwordValid = false
  //    }
  //  }

  //  if (passwordValid) {
  //    this.passwordvalidation.setErrors(null);
  //  }

  //  return passwordValid;
  //}

   ngAfterViewInit() {
     //this.usernameLabel = this.userNameElement?.nativeElement?.children[0]?.children[0].children[0].firstElementChild.innerText;
     //this.passwordLabel = this.passwordElement?.nativeElement?.children[0]?.children[0].children[0].firstElementChild.innerText;
     //this._reCaptchaId = this.captchaRef2?.nativeElement

     var RedirectToLogin = sessionStorage.getItem("isLogin") == "true" ? true : false;
     sessionStorage.removeItem("isLogin");
     if (!RedirectToLogin) {
       var UserNameHintField = document.getElementById("LoginUsernameHint");
       if (UserNameHintField != null || UserNameHintField != undefined) {
         UserNameHintField.className = UserNameHintField.className.includes("mt_1") ? "" : "mt_1";
       }
     }
   }
  loadLogo() {
    this.graphQlService.getS3BucketImageASCLogo().subscribe(data => {
      this.logo = this.domSanitizer.bypassSecurityTrustUrl(data);
    });
  }
  //loginProfessional() {
  //  let emailalid = this.checkEmail();
  //  if (emailalid) {
  //    this.showLoader();
  //    this._loginservice.redirecttoSSO(this.emailFormControl.value).subscribe(data => {
  //      if (data.byPassSSOAuthentication == false) {
  //        localStorage.setItem("DefaultSecView", "true");
  //        window.location.href = data.authorizeURL
  //        this.hideLoader();
  //      }
  //      else {
  //        localStorage.setItem("DefaultSecView", "true");
  //        var redirectRoute = localStorage.getItem("DeepLinkRoute");
  //        if (redirectRoute != "" && redirectRoute != undefined && redirectRoute != null) {
  //          this.route.navigateByUrl(redirectRoute);
  //        }
  //        else {
  //          this.route.navigateByUrl(data.authorizeURL);
  //        }

  //        this.hideLoader();
  //      }

  //    })
  //  }

  //}

  goToLink(url: string) {
    window.open(url, "_blank");
  }
  showLoader() {
    document.getElementById("loader-overlay").style.display = "block";
  }
  hideLoader() {
    document.getElementById("loader-overlay").style.display = "none";
  }

  switchToProView() {
    this.route.navigate(["/Login/proViewLogin"]);
  }

  showTC(closeButton) {
    this._commonDataService.showRightPanel.next(true);
    this._commonDataService.rightOverlayOption.next("Terms And Conditions");
    this._commonDataService.rightPanelWidth.next("rightOverlay_large");
    this._commonDataService.closeModalOption.next(closeButton);
  }

  contactSupportOverlay() {
    this._commonDataService.showRightPanel.next(true);
    this._commonDataService.rightOverlayOption.next("Contact Support");
    this._commonDataService.rightPanelWidth.next("rightOverLay_small");
  }
  openrightoverlay(event) {
    var loginHome = Array.from(document.getElementsByClassName('main-login-container') as HTMLCollectionOf<HTMLElement>);
    loginHome.forEach(x => {
      x.style.overflow = 'hidden';
    });
    let id = event.target.id;
    if (id != "") {
      this._commonDataService.showRightPanel.next(true);
      this._commonDataService.rightPanelWidth.next("rightOverlay_large");
      this._commonDataService.rightOverlayOption.next(id);
    }
  }
  openlinkbyId(event) {
    event.preventDefault();

    this.openlinkid.openLinkById(event,true);

  }
  onRightClick(event) {
    event.target.href = this.s3bucketbaseurl + "/" + event.target.id;

  }
}
